module.exports = __webpack_public_path__ + "static/img/诊疗风控@2x1.a8536796.png";